import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomButtonColors, atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationPosition,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

const BlockedUserToast = ({
  isToastVisible = false,
  onCloseToast,
  handleUnblockAndSubmitContactButton,
  notificationStatus = 'system',
  pageName
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {ADS_DETAIL_PAGE_NAME, PROFESSIONAL_STOCK_PAGE_NAME, USER_FAVORITE_ADS_PAGE_NAME} = config.get('page')

  const isMobile = config.get('isMobile')
  const isTablet = config.get('isTablet')
  const isDesktop = useMediaQuery(useMediaQueryBreakpoints.lg, {
    defaultMatches: !isMobile && !isTablet
  })

  const blockedUserToastClassNames = cx('mt-BlockedUserToast', {
    'mt-BlockedUserToast--fixed': pageName === ADS_DETAIL_PAGE_NAME && isDesktop
  })

  const notificationProps = {
    [ADS_DETAIL_PAGE_NAME]: {
      position: moleculeNotificationPosition.relative,
      variation: isDesktop ? moleculeNotificationVariations.negative : moleculeNotificationVariations.positive
    },
    [PROFESSIONAL_STOCK_PAGE_NAME]: {
      position: moleculeNotificationPosition.relative,
      variation: moleculeNotificationVariations.positive
    },
    [USER_FAVORITE_ADS_PAGE_NAME]: {
      position: moleculeNotificationPosition.relative,
      variation: moleculeNotificationVariations.positive
    }
  }

  const buttonProps = {
    [ADS_DETAIL_PAGE_NAME]: {negative: isDesktop},
    [PROFESSIONAL_STOCK_PAGE_NAME]: {negative: false},
    [USER_FAVORITE_ADS_PAGE_NAME]: {negative: false}
  }

  const BUTTONS = [
    {
      children: i18n.t('BLOCKED_USER_NOTIFICATION.BUTTON'),
      type: 'button',
      design: atomButtonDesigns.OUTLINE,
      shape: atomButtonShapes.CIRCULAR,
      color: atomButtonColors.PRIMARY,
      onClick: handleUnblockAndSubmitContactButton,
      alignment: 'right',
      negative: buttonProps[pageName]?.negative || false
    }
  ]

  const isSystemNotification = notificationStatus === 'system'
  const showCloseButton = pageName === 'ads-detail' && isDesktop
  const title = isSystemNotification
    ? i18n.t('BLOCKED_USER_NOTIFICATION.TITLE')
    : i18n.t('BLOCKED_USER_NOTIFICATION_SUCCESS.TITLE')
  const text = isSystemNotification
    ? i18n.t('BLOCKED_USER_NOTIFICATION.TEXT')
    : i18n.t('BLOCKED_USER_NOTIFICATION_SUCCESS.TEXT')
  const notificationType = isSystemNotification ? moleculeNotificationTypes.system : moleculeNotificationTypes.success

  return (
    <>
      {isToastVisible && (
        <div className={blockedUserToastClassNames}>
          <MoleculeNotification
            autoClose={moleculeNotificationAutoClose.manual}
            buttons={isSystemNotification && BUTTONS}
            onClose={() => onCloseToast(false)}
            roundedCorners={moleculeNotificationBorderSizes.medium}
            show={isToastVisible}
            showCloseButton={showCloseButton}
            type={notificationType}
            {...notificationProps[pageName]}
          >
            <div className="mt-BlockedUserToast-toast">
              <p className="mt-BlockedUserToast-toastTitle">{title}</p>
              <p className="mt-BlockedUserToast-toastText">{text}</p>
            </div>
          </MoleculeNotification>
        </div>
      )}
    </>
  )
}

BlockedUserToast.displayName = 'BlockedUserToast'
BlockedUserToast.propTypes = {
  isToastVisible: PropTypes.bool,
  onCloseToast: PropTypes.func,
  handleUnblockAndSubmitContactButton: PropTypes.func,
  notificationStatus: PropTypes.string,
  pageName: PropTypes.string
}

export default BlockedUserToast
